module.exports = __webpack_public_path__ + "img/delete-orange.2cdc9ba3.svg";